module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Light.31290eff.woff2";